import { useStore } from '@/store';

export default defineNuxtPlugin(nuxt => {
  const store = useStore(nuxt.$pinia);

  addRouteMiddleware('my-middleware', (to, from) => {
    //var langPattern = /[\/][a-z]{2}[\/]/
    if (to.params?.lang) {
      //var idioma = to.fullPath.substring(1, 3)
      store.setIdioma(to.params.lang)
    }else if(store.idioma!="es"){
      return navigateTo('/'+store.idioma+to.fullPath)
    }
    console.log(store.idioma)
  }, { global: true });
});

// for non-global middleware use this:


// addRouteMiddleware('named-test', (to, from) => {
//   //console.log('this named middleware was added in a plugin')
// })

